'use client';
import { useTranslations } from 'next-intl';
import { useBreakpoint, useNavigateTo } from '../../hooks';
import { BottomContainer, FooterLink, FooterSection, WrapContainer } from './styles';
import { Column } from '../../styles';
import { ROUTES } from '../../../constants';
import { TextButton } from '../buttons';
import { ArrowUpward, Language, LocalLibrary } from '@mui/icons-material';
import { DigitalhubDivider } from '../divider/DigitalhubDivider';

type Props = {
    isLandingPage?: boolean;
};

const Footer = ({ isLandingPage }: Props) => {
    const t = useTranslations('footer');
    const breakpoint = useBreakpoint();
    const navigateTo = useNavigateTo();

    const onScrollUp = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <Column aria-label='Footer Container'>
            {isLandingPage ? null : <DigitalhubDivider />}
            <FooterSection breakpoint={breakpoint}>
                <TextButton
                    icon={<LocalLibrary />}
                    label={t('simple_language')}
                    onClick={() => navigateTo(ROUTES.SimpleLanguage)}
                    color='primary'
                />
                <WrapContainer breakpoint={breakpoint}>
                    <TextButton
                        icon={<Language />}
                        label={t('to_digitalhub_website')}
                        href='https://digitalhub.sh/'
                    />
                    <TextButton icon={<ArrowUpward />} label={t('scroll_to_top')} onClick={onScrollUp} />
                </WrapContainer>
            </FooterSection>
            <DigitalhubDivider />
            <FooterSection breakpoint={breakpoint}>
                <BottomContainer breakpoint={breakpoint}>
                    <WrapContainer stretch breakpoint={breakpoint}>
                        <FooterLink href={ROUTES.Contact}>{t('contact')}</FooterLink>
                        <FooterLink href={ROUTES.Imprint}>{t('imprint')}</FooterLink>
                        <FooterLink href={ROUTES.Privacy}>{t('privacy')}</FooterLink>
                        <FooterLink href={ROUTES.Privacy}>{t('accessibility')}</FooterLink>
                    </WrapContainer>
                </BottomContainer>
            </FooterSection>
        </Column>
    );
};

export { Footer };
